<script lang="ts" setup>
const props = defineProps<{
  headline?: string;
  subheadline?: string;
  sticker?: boolean;
}>();

useHeaderColor("black");
</script>
<template>
  <header class="header-default relative h-4/6 bg-integer-black">
    <div class="outer-space container">
      <div
        class="grid h-full w-full grid-cols-12 content-end py-15 pt-50 text-integer-white"
      >
        <div class="col-span-12 md:col-span-9">
          <p v-if="props.subheadline" class="font-subline mb-4">
            {{ props.subheadline }}
          </p>
          <h1 class="hyphens-auto font-pixel text-h2 md:text-h1 2xl:text-h1max">
            {{ props.headline }}
          </h1>
        </div>
      </div>
    </div>
  </header>
</template>
